module.exports = __webpack_public_path__ + "img/publish.95deeef5.png";